import React, { useEffect, useState } from "react";
import { Container, Typography, Link} from "@mui/material";
import SignupForm from "../../components/SignupForm";
import Logo from "../../components/Logo";
import { motion } from "framer-motion";

let easing = [0.6, -0.05, 0.01, 0.99];
const fadeInUp = {
  initial: {
    y: 40,
    opacity: 0,
    transition: { duration: 0.6, ease: easing },
  },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      ease: easing,
    },
  },
};

function getSystemTheme() {
  try {
    const mq = window.matchMedia?.("(prefers-color-scheme: dark)");
    return mq && mq.matches ? "dark" : "light";
  } catch {
    return "light";
  }
}

function getInitialTheme() {
  try {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = params.get("theme"); 
    if (fromUrl === "dark" || fromUrl === "light") return fromUrl;
    return getSystemTheme();
  } catch {
    return "light";
  }
}

function applyTheme(theme) {
  const next = theme === "dark" ? "dark" : "light";
  document.documentElement.setAttribute("data-theme", next);
}


const Signup = ({ setAuth }) => {

    useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      const override = params.get("theme");
  
      applyTheme(getInitialTheme());
  
      if (!override || override === "system") {
        const mq = window.matchMedia?.("(prefers-color-scheme: dark)");
        const handler = (e) => applyTheme(e.matches ? "dark" : "light");
        if (mq) {
          if (mq.addEventListener) mq.addEventListener("change", handler);
          else if (mq.addListener) mq.addListener(handler); 
          return () => {
            if (mq.removeEventListener) mq.removeEventListener("change", handler);
            else if (mq.removeListener) mq.removeListener(handler);
          };
        }
      }
    }, []);

  const [isDark, setIsDark] = useState(
    document.documentElement.getAttribute("data-theme") === "dark"
  );

  useEffect(() => {
    const el = document.documentElement;
    const update = () =>
      setIsDark(el.getAttribute("data-theme") === "dark");

    update();

    const obs = new MutationObserver(update);
    obs.observe(el, { attributes: true, attributeFilter: ["data-theme"] });

    return () => obs.disconnect();
  }, []);

  return (
    <div className="root">
      <Container className="container" maxWidth="sm">
        <div className="card-content">
          <div className="sub-content">
            <div className="heading" component={motion.div} {...fadeInUp}>
              <Logo />
            </div>

            <SignupForm setAuth={setAuth} />

            {/* Commented until fixed the internal redirect back to app */}
            {/* <Typography
              component={motion.p}
              {...fadeInUp}
              variant="body2"
              align="center"
              sx={{ mt: 5 }}
            >
              Already have an account?{" "}
              <Link
                variant="subtitle2"
                component={RouterLink}
                to="/login"
                style={{ color: "#00C56E" }}
              >
                Sign in
              </Link>
            </Typography> */}

            <Typography
              component={motion.p}
              {...fadeInUp}
              variant="body2"
              align="center"
              sx={{ mt: 2 }}
              style={{ color: isDark ? "#FFF" : "#000" }} 
            >
              By signing up, I agree to 1receipt's{" "}
              <Link
                underline="always"
                href="https://www.1receipt.io/privacy"
                style={{ color: "#00C56E" }}
              >
                privacy policy
              </Link>{" "}
              and{" "}
              <Link
                underline="always"
                href="https://www.1receipt.io/terms"
                style={{ color: "#00C56E" }}
              >
                terms of service
              </Link>.{" "}
            </Typography>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Signup;
